import {useGetServiceOrderMandatoryFieldsQuery} from '@dms/api/workshop';

export function useOrderMandatoryFields(serviceOrderId: string) {
  const {data, isLoading, isError} = useGetServiceOrderMandatoryFieldsQuery({serviceOrderId});

  const isFieldRequired = (name: string) => !!data?.mandatoryFields?.includes(name);

  return {data, isLoading, isError, isFieldRequired};
}
